import { render } from "./color-sketch.vue?vue&type=template&id=e64ba5e2&scoped=true&ts=true"
import script from "./color-sketch.vue?vue&type=script&lang=ts"
export * from "./color-sketch.vue?vue&type=script&lang=ts"

import "./color-sketch.vue?vue&type=style&index=0&id=e64ba5e2&lang=scss"
import "./color-sketch.vue?vue&type=style&index=1&id=e64ba5e2&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86134\\Desktop\\Web\\Item\\来画设计\\laiiva-web\\packages\\QColor\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e64ba5e2"]])

export default __exports__